import * as React from 'react';

import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from './components/ui/empty.js';
import { cn } from './lib/utils.js';

export function DimeEmpty({ ...props }: Readonly<React.ComponentProps<typeof Empty>>) {
  return <Empty {...props} />;
}

export function DimeEmptyHeader({ ...props }: Readonly<React.ComponentProps<typeof EmptyHeader>>) {
  return <EmptyHeader {...props} />;
}

export function DimeEmptyMedia({
  className,
  ...props
}: Readonly<React.ComponentProps<typeof EmptyMedia>>) {
  return <EmptyMedia className={cn('mb-0', className)} {...props} />;
}

export function DimeEmptyTitle({ ...props }: Readonly<React.ComponentProps<typeof EmptyTitle>>) {
  return <EmptyTitle {...props} />;
}

export function DimeEmptyDescription({
  ...props
}: Readonly<React.ComponentProps<typeof EmptyDescription>>) {
  return <EmptyDescription {...props} />;
}

export function DimeEmptyContent({
  ...props
}: Readonly<React.ComponentProps<typeof EmptyContent>>) {
  return <EmptyContent {...props} />;
}
